import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import Portion from './Portion';

class MealCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionState: false,
    };
  }

  toggleAccordion = (id) => {
    this.setState((prevState) => ({
      accordionState: !prevState.accordionState,
    }));
  };

  render() {
    const { meals, meal_id, extra_macros } = this.props;
    const { accordionState } = this.state;
    const meal = meals.find((m) => m.uuid === meal_id);
    const { label, portions, macros } = meal;
    const foods = [];
    portions.map((p) => foods.push(p.name));

    // Find extra macros for this meal
    const mealExtraMacros = extra_macros?.find((em) => em.meal_uuid === meal_id);

    // Add "Custom Macros" to the foods list if there are extra macros
    if (mealExtraMacros) {
      foods.push('Custom Macros');
    }

    return (
      <div>
        <Card className="card-default card-container mb-3 meal-card" onClick={() => this.toggleAccordion()}>
          <CardHeader>{label}</CardHeader>
          {((portions && portions.length > 0) || mealExtraMacros) && (
            <>
              <CardBody className={accordionState ? 'expanded' : ''}>
                {!accordionState && (foods.join(', '))}
                <div className="macros d-flex flex-row">
                  <div className="macro first">
                    <div className="macro-label">C</div>
                    <div className="macro-value">{macros.carbs_met}{!accordionState && <>g</>}</div>
                    {accordionState && <div className="macro-target">/{macros.carbs_target}g</div>}
                  </div>
                  <div className="macro">
                    <div className="macro-label">P</div>
                    <div className="macro-value">{macros.protein_met}{!accordionState && <>g</>}</div>
                    {accordionState && <div className="macro-target">/{macros.protein_target}g</div>}
                  </div>
                  <div className="macro">
                    <div className="macro-label">F</div>
                    <div className="macro-value">{macros.fat_met}{!accordionState && <>g</>}</div>
                    {accordionState && <div className="macro-target">/{macros.fat_target}g</div>}
                  </div>
                  <div className="macro">
                    <div className="macro-label">Cal</div>
                    <div className="macro-value">{macros.calories_met}</div>
                    {accordionState && <div className="macro-target">/{macros.calories_target}</div>}
                  </div>
                </div>
              </CardBody>
              <Collapse isOpen={accordionState}>
                <CardBody>
                  {portions.map((p, idx) => (
                    <Portion className={idx === 0 ? 'first' : ''} key={p.uuid} portion={p} />
                  ))}
                  {mealExtraMacros && (
                    <div className="portion-container">
                      <div className="d-flex flex-row justify-space-between">
                        <div className="portion-name">
                          Custom Macros
                        </div>
                      </div>
                      <div className="macros d-flex flex-row">
                        <div className="macro first">
                          <div className="macro-label">C</div>
                          <div className="macro-value">{Math.round(mealExtraMacros.carbs)}g</div>
                        </div>
                        <div className="macro">
                          <div className="macro-label">P</div>
                          <div className="macro-value">{Math.round(mealExtraMacros.protein)}g</div>
                        </div>
                        <div className="macro">
                          <div className="macro-label">F</div>
                          <div className="macro-value">{Math.round(mealExtraMacros.fat)}g</div>
                        </div>
                        <div className="macro">
                          <div className="macro-label">Cal</div>
                          <div className="macro-value">{Math.round(mealExtraMacros.calories)}</div>
                        </div>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Collapse>
            </>
          )}
        </Card>
      </div>
    );
  }
}

MealCard.propTypes = {
  meals: PropTypes.instanceOf(Array),
  meal_id: PropTypes.string,
  extra_macros: PropTypes.instanceOf(Array),
};

export default MealCard;
